const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo y descripción */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Rebel Ink
            </h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Arte corporal profesional con pasión y dedicación. Transformamos tu visión en arte permanente con las mejores técnicas y cuidado.
            </p>
            <div className="mb-6">
              <p className="text-pink-400 font-semibold mb-2">
                <i className="ri-spa-line mr-2"></i>
                Nuestro hermano: Rebel Spa
              </p>
              <p className="text-gray-400 text-sm">
                Tratamientos corporales, faciales y de bienestar
              </p>
            </div>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/rebel_rabbit_tattoo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://wa.me/56982504829"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-green-600 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-lg font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#inicio" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer whitespace-nowrap">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer whitespace-nowrap">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#galeria" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer whitespace-nowrap">
                  Galería
                </a>
              </li>
              <li>
                <a href="#artistas" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer whitespace-nowrap">
                  Nuestras Artistas
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer whitespace-nowrap">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400">
                <i className="ri-map-pin-line mt-1 mr-3 text-pink-400"></i>
                <span>Las Urbinas 87, Oficina 26<br />Providencia, Santiago, Chile</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line mr-3 text-pink-400"></i>
                <a href="tel:+56982504829" className="hover:underline">+56 9 8250 4829</a>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-mail-line mr-3 text-pink-400"></i>
                <a href="mailto:contacto@rebelrabbit.cl" className="hover:underline">contacto@rebelrabbit.cl</a>
              </li>
              <li className="flex items-start text-gray-400 mt-4 pt-4 border-t border-gray-800">
                <i className="ri-spa-line mt-1 mr-3 text-pink-400"></i>
                <div>
                  <strong className="text-pink-400 block mb-1">Rebel Spa</strong>
                  <span className="text-sm block mb-2">Tratamientos corporales</span>
                  <div className="space-y-1 text-sm">
                    <div className="flex items-center">
                      <i className="ri-phone-line mr-2"></i>
                      <a href="tel:+56979562250" className="hover:underline">+56 9 7956 2250</a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-2"></i>
                      <a href="mailto:contacto@rebelspa.cl" className="hover:underline">contacto@rebelspa.cl</a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} Rebel Ink. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
